// extracted by mini-css-extract-plugin
export var bounce = "_p7-1";
export var generatingText = "_p7-6";
export var lightning = "_p7-4";
export var popup = "_p7-5";
export var progressBar = "_p7-7";
export var progressFill = "_p7-8";
export var progressShimmer = "_p7-9";
export var progressText = "_p7-a";
export var shimmer = "_p7-3";
export var uploadIcon = "_p7-0";
export var uploadingText = "_p7-2";